import React from "react";
import './Hr.css';

function Hr() {
    return (
        <b className="hr anim"></b>
    );
}

export default Hr;